export default __webpack_public_path__ + "static/media/banner.2043fdd2.svg";